module.exports = __webpack_public_path__ + "static/media/BG.fe4fd3ab.jpg";